export default __webpack_public_path__ + "static/media/Bandit's Belt of the Khan.1c7dbcf3.jpg";